import { ListDataRequestResponse } from "go-core/api/types";

export const getResponseHasNextPage = (response: Array<any> | ListDataRequestResponse): boolean | undefined =>
	Array.isArray(response) ? undefined : response.nextPage;
